import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import {useFluxStore} from 'client/framework';
import sessionStore from 'client/Session/SessionStore';

import useStudentGuess from './useStudentGuess';

/**
 * Whether this submission is still awaiting its teacher's grade — the student-facing half of
 * teacher-controlled release.
 *
 * `evaluationReleased` is the whole condition: it is true whenever the question isn't manually
 * graded, so a false inside an assignment means precisely "manually graded, not yet released to
 * me". That also keeps the awaiting state for a student whose grade was still incomplete when the
 * class was released, which is what the spec asks for and what a status check could not express.
 *
 * Not `gradeAvailable` — that is also false when the assignment's show-correct-answers setting is
 * shut, which would claim a teacher is grading questions nobody is grading.
 */
export default function useFrqPendingTeacherGrading(questionId: string | undefined): boolean {
  const isStudent = useFluxStore(sessionStore, (s) => s.isStudent());
  const {isFeatureEnabled} = useIsFeatureFlagEnabled('frq_teacher_grading');
  const {guess} = useStudentGuess(questionId);

  return isFeatureEnabled && isStudent && guess?.evaluationReleased === false;
}
